import React from "react";
import siteContent from "../../../generated/site-content";

function ImpressumPage() {
  const impressum = siteContent.pages.impressum;

  return (
    <section className="w-full max-w-4xl py-2">
      <div className="max-w-3xl">
        <h1 className="theme-text text-3xl font-semibold tracking-tight">
          {impressum.title}
        </h1>
        <p className="theme-text-muted mt-2 text-sm leading-6 sm:text-base">
          {impressum.intro}
        </p>
      </div>

      <div className="mt-5 max-w-3xl space-y-3">
        <section className="theme-surface rounded-2xl border theme-border p-4 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {impressum.addressLabel}
          </p>
          <div className="theme-text-soft mt-3 space-y-0.5 text-sm leading-6 sm:text-base">
            <p className="theme-text font-medium">{impressum.addressName}</p>
            {impressum.addressLines.map((line) => (
              <p key={line}>{line}</p>
            ))}
          </div>

        </section>

        <section className="theme-surface rounded-2xl border theme-border p-4 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {impressum.contactLabel}
          </p>
          <p className="theme-text-soft mt-3 text-sm leading-6 sm:text-base">
            <span className="theme-text font-medium">{impressum.emailLabel}: </span>
            <a className="theme-link" href={siteContent.contact.emailHref}>
              {siteContent.contact.emailLabel}
            </a>
          </p>
        </section>

        <section className="theme-surface rounded-2xl border theme-border p-4 shadow-sm">
          <p className="theme-text-muted text-xs font-semibold uppercase tracking-[0.24em]">
            {impressum.responsibleLabel}
          </p>
          <div className="theme-text-soft mt-3 space-y-0.5 text-sm leading-6 sm:text-base">
            <p className="theme-text font-medium">{impressum.responsibleName}</p>
            {impressum.responsibleAddressLines.map((line) => (
              <p key={line}>{line}</p>
            ))}
          </div>
        </section>
      </div>
    </section>
  );
}

export default ImpressumPage;
